<script setup>
import { ref } from 'vue'
import axios from 'axios'
import SmartCaptcha from 'vue3-smart-captcha'

const dialog = ref(false)
const isLoading = ref(false)

const name = ref('')
const text = ref('')
const nameTextRules = ref([
    (value) => {
        if (value) return true
        return 'Обязательное поле для заполнения'
    }
])

const email = ref('')
const emailRules = ref([
    (value) => {
        if (value) return true

        return 'Обязательное поле для заполнения'
    },
    (value) => {
        if (/.+@.+\..+/.test(value)) return true

        return 'Неверный вид Email'
    }
])

const SMARTCAPTCHA_KEY = process.env.VUE_APP_SMARTCAPTCHA_KEY
const captchaToken = ref('')

const handleSuccessCaptcha = (token) => {
    captchaToken.value = token
}

const sendFeedback = async () => {
    if (
        name.value.trim().length === 0 ||
        text.value.trim().length === 0 ||
        email.value.trim().length === 0 ||
        !/.+@.+\..+/.test(email.value) ||
        captchaToken.value.trim().length === 0
    ) {
        alert('Проверьте веденные данные и попробуйте еще раз')
        return
    }

    let startUrl = ''
    if (process.env.VUE_APP_SERVER_URL) {
        startUrl = process.env.VUE_APP_SERVER_URL
    }
    if (!startUrl) {
        startUrl = window.location.origin + '/api'
    }

    isLoading.value = true

    try {
        await axios.post(startUrl + '/feedback', {}, {
            params: {
                sender_name: name.value,
                sender_email: email.value,
                text: text.value,
                captcha_token: captchaToken.value
            }
        })
 
        alert('Сообщение было успешно отправлено')

        name.value = ''
        email.value = ''
        text.value = ''
    } catch (error) {
        if (error.status === 403) {
            alert('Вы не прошли проверку CAPTCHA')
        } else if (error.status === 503) {
            alert('Произошла ошибка на сервере, попробуйте позднее')
        }
    } finally {
        dialog.value = false
        captchaToken.value = ''
        isLoading.value = false
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        max-width="800"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <svg
                v-bind="activatorProps"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M31.7834 23.1333L21.6667 33.2333V36.6667H25.1L35.2 26.55M37.8334 22.6333L35.7 20.5C35.5334 20.3167 35.3 20.2167 35.0667 20.2167C34.8167 20.2333 34.5834 20.3167 34.4167 20.5L32.75 22.1667L36.1667 25.5L37.8334 23.8333C38.15 23.5 38.15 22.9667 37.8334 22.6333ZM18.3334 30H6.66671V13.3333L20 21.6667L33.3334 13.3333V16.6667H36.6667V10C36.6667 8.16667 35.1667 6.66667 33.3334 6.66667H6.66671C4.83337 6.66667 3.33337 8.16667 3.33337 10V30C3.33337 31.8333 4.83337 33.3333 6.66671 33.3333H18.3334V30ZM33.3334 10L20 18.3333L6.66671 10H33.3334Z"
                    fill="white"
                />
            </svg>
        </template>

        <template v-slot:default>
            <v-card>
                <div class="container">
                    <h1 class="title">Обратная связь</h1>
                    <form
                        class="inputs"
                        @submit.prevent="sendFeedback"
                    >
                        <v-text-field
                            v-model="name"
                            :rules="nameTextRules"
                            label="Как к вам обращаться?"
                            variant="outlined"
                        />
                        <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="Укажите Ваш Email для обратной связи"
                            variant="outlined"
                        />
                        <v-textarea
                            v-model="text"
                            :rules="nameTextRules"
                            label="Текст сообщения"
                            variant="outlined"
                        />
                        <SmartCaptcha
                            :sitekey="SMARTCAPTCHA_KEY"
                            hl="ru"
                            @success="handleSuccessCaptcha"
                        />
                        <v-btn
                            class="submit-btn"
                            color="rgba(59, 102, 211, 1)"
                            :disabled="captchaToken.trim().length === 0 || isLoading"
                            type="submit"
                        >
                            {{ !isLoading ? 'Отправить' : 'Отправка...' }}
                        </v-btn>
                    </form>
                </div>
            </v-card>
        </template>
    </v-dialog>
</template>

<style lang="scss" scoped>
.container {
    padding: 40px 50px;
}

.title {
    font-size: 28px;
    font-weight: 500;
    line-height: 36px;
}

.inputs {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.submit-btn {
    width: 100%;
    height: 56px;
}
</style>
